import { forwardRef } from "react";

import { SettingOutlined } from "@ant-design/icons";

import { cn } from "@/lib/utils";

const ICON_CLASSES = "self-center text-lg";
const LABEL_CLASSES = "text-sm font-normal my-0 px-1";
const SIDEBAR_BUTTON_CLASSES = "flex flex-col gap-2";

const MyAccountButton = forwardRef<HTMLDivElement>((props, ref) => (
  <div
    {...props}
    ref={ref}
    className={cn(SIDEBAR_BUTTON_CLASSES, "cursor-pointer")}
  >
    <SettingOutlined className={ICON_CLASSES} />
    <p className={LABEL_CLASSES}>Minha Conta</p>
  </div>
));

MyAccountButton.displayName = "MyAccountButton";

export default MyAccountButton;
